export default __webpack_public_path__ + "static/media/octasmart-icon.fc56f466.svg";